import React, { useContext, useEffect, useRef, useState } from 'react';
import {
    GetInternalDashHeaderRecords,
    GetInternalDashReturnReasons,
    GetInternalDashTechnicianJobs,
    GetInternalDashClockEntries,
    GetUserPreferenceWorkflowsList
} from '../Service/dashbordService';
import { Card, Grid, Typography, Avatar, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ChartCommonComp } from '../Chart/barChart';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';
import { PieChart, Pie, Sector, LabelList } from 'recharts';
import { CodeSharp, ContactsOutlined } from '@material-ui/icons';
import HomeIcon from '@material-ui/icons/Home';
import FilterListIcon from '@material-ui/icons/FilterList';
import _ from 'lodash';
import GijgoGrid from '../../Components/internal/dashboard';
import AppContext from '../../App/AppContext';
import moment from 'moment';
import { IconButton } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ReactDOM from 'react-dom';
import DashboardCharts from './dashboardCharts';
import GridFilterModal from '../../Components/internal/dashboard/FilterModal';
import AssignTech from '../../Components/internal/assign-technician/assignTechnModal';
import DialogComp from '../Modal/dialogModal';
import { getGridFilterList } from '../Service/workflow-service';
import Grow from '@material-ui/core/Grow';
import { useHistory } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { useWindowSize } from '../Controls/ScreenResolution';
import { async } from 'q';
import { WorkFlowDragNDropComponent } from './WorkFlowDragNDropComponent';
import FilterModalMainTabComponent from '../../Components/internal/dashboard/FilterModalMainTabComp';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        background: '#f5f5f5',
        border: '2px solid #f5f5f5 ',
        Opacity: 0.9,
        minWidth: 110,
        padding: '5px 0px',
        margin: 3,
        borderRadius: 3
    }
}));

let config = {
    // act: {
    //     from: '',
    //     to: '',
    //     getSequence: 'actionSequence',
    //     postSequence: 'actionSequence'
    // },
    wipNo: {
        from: 'displayWIPNo',
        to: 'userGridColumnDisplayWIPNo',
        getSequence: 'wipNoSequence',
        postSequence: 'WIPNoSequence'
    },
    registration: {
        from: 'displayVehicleReg',
        to: 'userGridColumnDisplayVehicleReg',
        getSequence: 'vehicleRegSequence',
        postSequence: 'VehicleRegSequence'
    },
    makeModel: {
        from: 'displayModel',
        to: 'userGridColumnDisplayModel',
        getSequence: 'modelSequence',
        postSequence: 'modelSequence'
    },
    customerName: {
        from: 'displayCustomer',
        to: 'userGridColumnDisplayCustomer',
        getSequence: 'customerSequence',
        postSequence: 'customerSequence'
    },
    dateDueIn: {
        from: 'displayDateDueIn',
        to: 'userGridColumnDisplayDateDueIn',
        getSequence: 'dateDueInSequence',
        postSequence: 'dateDueInSequence'
    },
    dateDueOut: {
        from: 'displayDateDueOut',
        to: 'userGridColumnDisplayDateDueOut',
        getSequence: 'dateDueOutSequence',
        postSequence: 'dateDueOutSequence'
    },
    returnReason: {
        from: 'displayReturnReason',
        to: 'userGridColumnDisplayReturnReason',
        getSequence: 'returnReasonSequence',
        postSequence: 'returnReasonSequence'
    },
    branchShortName: {
        from: 'displayBranch',
        to: 'userGridColumnDisplayBranch',
        getSequence: 'branchSequence',
        postSequence: 'branchSequence'
    },
    franchiseName: {
        from: 'displayFranchise',
        to: 'userGridColumnDisplayFranchise',
        getSequence: 'franchiseSequence',
        postSequence: 'franchiseSequence'
    },
    serviceText: {
        from: 'displayJobDescription',
        to: 'userGridColumnDisplayJobDescription',
        getSequence: 'jobDescriptionSequence',
        postSequence: 'jobDescriptionSequence'
    },
    accountNo: {
        from: 'displayAccount',
        to: 'userGridColumnDisplayAccount',
        getSequence: 'accountSequence',
        postSequence: 'accountSequence'
    },
    createdBy: {
        from: 'displayCreatedBy',
        to: 'userGridColumnDisplayCreatedBy',
        getSequence: 'createdBySequence',
        postSequence: 'createdBySequence'
    },
    assigned: {
        from: 'displayAssignedDate',
        to: 'userGridColumnDisplayAssignedDate',
        getSequence: 'assignedDateSequence',
        postSequence: 'assignedDateSequence'
    },
    taken: {
        from: 'displayTimeTaken',
        to: 'userGridColumnDisplayTimeTaken',
        getSequence: 'timeTakenSequence',
        postSequence: 'timeTakenSequence'
    },
    status: {
        from: 'displayStatus',
        to: 'UserGridColumnDisplayStatus',
        getSequence: 'statusSequence',
        postSequence: 'statusSequence'
    },
    assignedDays: {
        from: 'displayAssignedDays',
        to: 'UserGridColumnDisplayAssignedDays',
        getSequence: 'assignedDaysSequence',
        postSequence: 'assignedDaysSequence'
    },
    owningOperator: {
        from: 'displayOwningOperator',
        to: 'UserGridDisplayColumnOwningOperator',
        getSequence: 'owningOperatorSequence',
        postSequence: 'owningOperatorSequence'
    },
    jobAssignedUser: {
        from: 'displayJobAssignedUser',
        to: 'UserGridColumnDisplayJobAssignedUser',
        getSequence: 'jobAssignedUserSequence',
        postSequence: 'jobAssignedUserSequence'
    },
    chassisNumber: {
        from: 'displayChassisNumber',
        to: 'UserGridColumnDisplayChassisNumber',
        getSequence: 'chassisNumberSequence',
        postSequence: 'chassisNumberSequence'
    },
    courtesyCarReq: {
        from: 'displayCourtesyCarReq',
        to: 'UserGridColumnDisplayCourtesyCarReq',
        getSequence: 'courtesyCarReqSequence',
        postSequence: 'courtesyCarReqSequence'
    },
    customerWaiting: {
        from: 'displayCustomerWaiting',
        to: 'UserGridColumnDisplayCustomerWaiting',
        getSequence: 'customerWaitingSequence',
        postSequence: 'customerWaitingSequence'
    },
    wipAge: {
        from: 'displayWIPAge',
        to: 'UserGridColumnDisplayWIPAge',
        getSequence: 'wipAgeSequence',
        postSequence: 'wipAgeSequence'
    },
    isNightShift: {
        from: 'displayIsNightShift',
        to: 'UserGridColumnDisplayIsNightShift',
        getSequence: 'isNightShiftSequence',
        postSequence: 'isNightShiftSequence'
    }
};

const isFalseValue = (val) => {
    if (val == false) {
        return false;
    } else {
        return true;
    }
};

// function scrollbarVisible(element) {
//     console.log(element?.clientWidth, 'element?.clientWidth');
//     console.log(element?.scrollWidth, 'element?.scrollWidth');
//     return element?.scrollWidth > element?.clientWidth;
// }

function scrollbarVisible(element) {
    if (!element) return false;
    return element.scrollWidth >= element.clientWidth;
}

// const scrollNext = (id) => {
//     document.getElementById('WorkFlow-Btn').scrollBy({ left: 100, top: 0, behavior: 'smooth' });
// };

// const scrollPrev = (id) => {
//     document.getElementById('WorkFlow-Btn').scrollBy({ left: -100, top: 0, behavior: 'smooth' });
// };

const Dashbord = (props) => {
    const workflowRef = useRef(null);

    const scrollNext = () => {
        workflowRef.current?.scrollBy({ left: 100, top: 0, behavior: 'smooth' });
    };

    const scrollPrev = () => {
        workflowRef.current?.scrollBy({ left: -100, top: 0, behavior: 'smooth' });
    };

    const classes = useStyles();
    const { portalSettings, getUserPreference, isAppReload } = useContext(AppContext);
    // const { t, i18n, langLabel } = Customi18();
    const [checked, setChecked] = useState(false);
    let history = useHistory();
    const [WindowWidths, WindowHeights] = useWindowSize();
    const [state, setState] = useState({
        isShowScrollArrow: true,
        getUrl: `WorkflowJobs/GetWorkflow`,
        workflowData: [],
        chartdata: [],
        headerRecord: [],
        tempHeaderRecord: [],
        rawHeaderData: [],
        returnReasonBarData: [],
        returnReasons: [],
        allHeaderDataKeys: [],
        allHeaderData: [],
        workFlowDataBarData: [],
        workFlowDatakeys: [],
        sumOfAllWorkflows: [],
        btnID: 'home',
        tempObj: {},
        showGrid: false,
        total: '',
        headervalbyBranch: [],
        returnReasonColors: [],
        selectListForRR: [],
        selectedBranch: 'Default',
        showLoader: true,
        clockedHours: [],
        showClokedHours: true,
        showHeaderLoader: true,
        showReturnReasonLoader: true,
        showTechnicianLoader: true,
        technicianJobsData: [],
        UserPreferenceWorkflowsList: [],
        franchiseStatus: [],
        uniqueFranchises: [],
        uniqueBranchFranchises: [],
        showJobHeader: {},
        assignedJobs: [],
        selectedUser: '',
        assignedUserList: []
    });

    const pullGridFilterList = async () => {
        let data = getUserPreference();
        if (data) {
            // i18n.changeLanguage(data.details[0].languageCode);
            setState((st) => ({
                ...st,
                appbarLocation: data.details[0].appbarLocation || 'T',
                languageCode: data.details[0].languageCode,
                languageData: data.languages,
                tempObj: data.details[0] || {},
                displayPagination: isFalseValue(data.details[0]?.displayPagination),
                showJobHeader: {
                    showHeaderWIPNumber: data.details[0]?.showHeaderWIPNumber || false,
                    showHeaderRegNumber: data.details[0]?.showHeaderRegNumber || false,
                    showHeaderCustomer: data.details[0]?.showHeaderCustomer || false,
                    showHeaderKeyNumber: data.details[0]?.showHeaderKeyNumber || false,
                    showHeaderChassisNumber: data.details[0]?.showHeaderChassisNumber || false,
                    showHeaderOutstandingPayment: data.details[0]?.showHeaderOutstandingPayment || false,
                    showHeaderCreditLimit: data.details[0]?.showHeaderCreditLimit || false,
                    showHeaderWorkDetails: data.details[0]?.showHeaderWorkDetails || false,
                    showHeaderCashMessage: data.details[0]?.showHeaderCashMessage || false
                }
            }));
        }
    };

    const GetClockedHours = async () => {
        try {
            const clockedHoursFromAPI = await GetInternalDashClockEntries(props.processID);

            if (!clockedHoursFromAPI?.success) {
                console.warn('GetClockedHours API failed or returned no success flag');
                setState((st) => ({ ...st, showClokedHours: false }));
                return;
            }

            const clockedHours = clockedHoursFromAPI?.data?.clockedHours || [];
            const hoursRemaining = clockedHoursFromAPI?.data?.hoursRemaining || [];

            // 🔹 Merge duplicate workflows for clocked hours
            const allClockedHours = clockedHours.reduce((acc, ch) => {
                const existing = acc.find((item) => item.workflow === ch.workflow);
                if (existing) {
                    existing.hoursTaken += ch.hoursTaken;
                    existing.hoursAllowed += ch.hoursAllowed;
                } else {
                    acc.push({
                        bn: 'Default',
                        workflow: ch.workflow,
                        workflowID: ch.workflowID,
                        hoursTaken: ch.hoursTaken,
                        hoursAllowed: ch.hoursAllowed
                    });
                }
                return acc;
            }, []);

            // 🔹 Merge duplicate workflows for hours remaining
            const allHoursRemaining = hoursRemaining.reduce((acc, ch) => {
                const existing = acc.find((item) => item.workflow === ch.workflow);
                if (existing) {
                    existing.hoursRemaining += ch.hoursRemaining;
                } else {
                    acc.push({
                        bn: 'Default',
                        workflow: ch.workflow,
                        workflowID: ch.workflowID,
                        hoursRemaining: ch.hoursRemaining
                    });
                }
                return acc;
            }, []);

            setState((st) => ({
                ...st,
                clockedHours: allClockedHours, // ✅ avoids duplicates
                hoursRemaining: allHoursRemaining,
                showClokedHours: false
            }));
        } catch (error) {
            console.error('Error fetching clocked hours:', error);
            setState((st) => ({ ...st, showClokedHours: false }));
        }
    };

    function getUniqueList(arr, key) {
        const uniqueValues = new Set();
        return arr.filter((item) => {
            const isDuplicate = uniqueValues.has(item[key]);
            uniqueValues.add(item[key]);
            return !isDuplicate;
        });
    }

    const GetHeaderRecords = async () => {
        try {
            let GetHeaderRecordsFromAPI = await GetInternalDashHeaderRecords(props.processID);

            if (!GetHeaderRecordsFromAPI?.success || !GetHeaderRecordsFromAPI?.data) {
                console.error('GetHeaderRecords API failed or returned empty data');
                setState((st) => ({
                    ...st,
                    showHeaderLoader: false,
                    error: 'Failed to fetch header records'
                }));
                return;
            }

            let headerRecord = GetHeaderRecordsFromAPI.data?.headerRecord || [];
            let userPreferenceWorkflowsSequence = GetHeaderRecordsFromAPI.data?.userPreferenceWorkflows || [];
            let workshopLoadingStatusCode = GetHeaderRecordsFromAPI.data?.workshopLoadingStatusCode || [];
            let assignedJobs = GetHeaderRecordsFromAPI.data?.assignedJobs || [];
            // let selectedUser = GetHeaderRecordsFromAPI.data?.user?.[0]?.userID || null;

            let assignedUserList = [];
            if (assignedJobs.length > 0) {
                assignedUserList = getUniqueList(assignedJobs, 'userID');
            }

            if (workshopLoadingStatusCode.length > 0) {
                getfranchiseStatus(workshopLoadingStatusCode);
            }

            if (headerRecord.length === 0) {
                console.warn('No header records found');
                setState((st) => ({
                    ...st,
                    assignedUserList,
                    workflowData: [],
                    chartdata: [],
                    headerRecord: [],
                    userPreferenceWorkflowsSequence,
                    allHeaderDataKeys: [],
                    allHeaderData: [],
                    sumWorkflows: 0,
                    sumOFByTimeForALL: [],
                    rawHeaderData: [],
                    showHeaderLoader: false,
                    assignedJobs
                    // selectedUser
                }));
                return;
            }

            // ✅ Headers WorkFlows Data
            const headerWorkflowData = headerRecord.reduce((acc, obj) => {
                const index = acc.find((item) => item.workflow === obj.workflow);
                index ? (index.total += obj.total) : acc.push({ ...obj });
                return acc;
            }, []);

            // ✅ Workflow pieData
            const workflowData = headerWorkflowData.map((m) => ({
                name: m.workflow,
                value: m.total,
                workflowID: m.workflowID
            }));

            let sumOfAllWorkflows = workflowData.reduce((sum, item) => sum + item.value, 0);

            // ✅ Branch pieData
            let branchArr = headerRecord.reduce((acc, obj) => {
                const index = acc.find((item) => item.bn === obj.bn);
                index ? (index.total += obj.total) : acc.push({ ...obj });
                return acc;
            }, []);

            let chartdata = branchArr
                .filter((m) => m.bn)
                .map((m) => ({
                    name: m.bn,
                    value: m.total
                }));

            // ✅ Sum by time for ALL
            const sumOFByTimeForALL = headerRecord.reduce((acc, obj) => {
                var index = acc.find((item) => item.bn === obj.bn);
                if (index) {
                    index.lessThan24HoursOld += obj.lessThan24HoursOld;
                    index.between1And5DaysOld += obj.between1And5DaysOld;
                    index.between5And10DaysOld += obj.between5And10DaysOld;
                    index.between10And20DaysOld += obj.between10And20DaysOld;
                    index.between21And30DaysOld += obj.between21And30DaysOld;
                    index.over30DaysOld += obj.over30DaysOld;
                    index.preBooking += obj.preBooking;
                    index.between1to10Days += obj.between1to10Days;
                    index.between11And20Days += obj.between11And20Days;
                    index.between21And30Days += obj.between21And30Days;
                    index.overdueOver30DaysOld += obj.overdueOver30DaysOld;
                    index.overdueArchived += obj.overdueArchived;
                    return acc;
                }
                acc.push({ ...obj });
                return acc;
            }, []);

            // ✅ By branch and Time BarChart
            let headerByTimeBarchart = headerRecord.reduce((acc, obj) => {
                var index = acc.find((item) => item.workflow === obj.workflow && item.bn === obj.bn);
                if (index) {
                    index.lessThan24HoursOld += obj.lessThan24HoursOld;
                    index.between1And5DaysOld += obj.between1And5DaysOld;
                    index.between5And10DaysOld += obj.between5And10DaysOld;
                    index.between10And20DaysOld += obj.between10And20DaysOld;
                    index.between21And30DaysOld += obj.between21And30DaysOld;
                    index.over30DaysOld += obj.over30DaysOld;
                    index.total += obj.total;
                    return acc;
                }
                acc.push({ ...obj });
                return acc;
            }, []);

            const chartDataForHeader = headerByTimeBarchart.map((p) => ({
                name: p.bn,
                '<24hr': p.lessThan24HoursOld,
                '1-5 days': p.between1And5DaysOld,
                '5-10 days': p.between5And10DaysOld,
                '10-20 days': p.between10And20DaysOld,
                '21-30 days': p.between21And30DaysOld,
                '>30 days': p.over30DaysOld,
                workflow: p.workflow,
                workflowID: p.workflowID
            }));

            const result = chartDataForHeader.map((m) => {
                const newObj = chartDataForHeader.filter((n) => n.name === m.name);
                newObj.bn = m.name;
                return newObj;
            });

            let newResult = Object.values(result.reduce((acc, cur) => Object.assign(acc, { [cur.bn]: cur }), {}));

            let getAllHeaderKeys = newResult.map((m) => {
                let keys = m.map((p) => Object.keys(p));
                return keys;
            });

            setState((st) => ({
                ...st,
                assignedUserList,
                workflowData,
                chartdata,
                headerRecord: headerWorkflowData,
                userPreferenceWorkflowsSequence,
                allHeaderDataKeys: getAllHeaderKeys.length > 0 ? getAllHeaderKeys[0][0] : [],
                allHeaderData: newResult,
                sumWorkflows: sumOfAllWorkflows,
                sumOFByTimeForALL,
                rawHeaderData: headerRecord,
                showHeaderLoader: false,
                assignedJobs
                // selectedUser
            }));
        } catch (error) {
            console.error('Error in GetHeaderRecords:', error);
            setState((st) => ({
                ...st,
                showHeaderLoader: false,
                error: error.message || 'Unexpected error occurred'
            }));
        }
    };

    const getfranchiseStatus = (List) => {
        try {
            const result = List.filter((item) => item.franchise && item.franchiseCode && item.status).reduce((acc, obj) => {
                const index = acc.find((item) => item.franchiseCode === obj.franchiseCode && item.branchID === obj.branch && item.status === obj.status);
                index ? (index.jobs += obj.jobs) : acc.push({ ...obj });
                return acc;
            }, []);

            const franchiseTotal = List.reduce((acc, obj) => {
                const index = acc.find((item) => item.franchise === obj.franchise);
                index ? (index.jobs += obj.jobs) : acc.push({ ...obj });
                return acc;
            }, []);

            // Overall Frenchise Total

            const franchiseBranchTotal = List.reduce((acc, obj) => {
                const index = acc.find((item) => item.franchise === obj.franchise && item.branch === obj.branch);
                index ? (index.jobs += obj.jobs) : acc.push({ ...obj });
                return acc;
            }, []);

            // const uniFranchises = List.filter((item) => item.franchise && item.franchiseCode !== null) // Filter valid franchise and franchiseCode
            const uniqueFranchises = franchiseTotal.map((item) => ({ name: item.franchise, id: item.franchiseCode, total: item.jobs })); // Map franchise as name and franchiseCode as id
            const uniqueBranchFranchises = franchiseBranchTotal.map((item) => ({
                name: item.franchise,
                id: item.franchiseCode,
                total: item.jobs,
                branch: item.branch
            })); // Map franchise as name and franchiseCode as id

            setState((st) => ({
                ...st,
                franchiseStatus: result || [],
                uniqueFranchises: uniqueFranchises,
                uniqueBranchFranchises: uniqueBranchFranchises
            }));
        } catch (error) {
            console.error('Error in getfranchiseStatus:', error);
            setState((st) => ({
                ...st,
                franchiseStatus: [],
                uniqueFranchises: [],
                uniqueBranchFranchises: []
            }));
        }
    };

    const GetReturnReason = async (workflow, branchName) => {
        try {
            const responses = await GetInternalDashReturnReasons(props.processID);

            if (!responses?.success) {
                console.error('Failed to fetch return reasons:', responses?.message);
                setState((st) => ({
                    ...st,
                    showReturnReasonLoader: false,
                    workFlowDataBarData: [],
                    workFlowDatakeys: [],
                    returnReasonColors: []
                }));
                return;
            }

            const returnReason = responses?.data?.returnReasons ?? [];
            if (returnReason.length === 0) {
                console.warn('No returnReasons data found');
                setState((st) => ({
                    ...st,
                    showReturnReasonLoader: false,
                    workFlowDataBarData: [],
                    workFlowDatakeys: [],
                    returnReasonColors: []
                }));
                return;
            }

            // ✅ Extract colors once (common in both cases)
            const RetrunResoncolor = returnReason.map((m) => ({ rr: m.rr, color: m.cc }));

            if (workflow && branchName) {
                // ---------------- Branch + Workflow specific case ----------------
                const reduceReturnResonArray = returnReason.reduce((acc, obj) => {
                    const index = acc.find((item) => item.bn === obj.bn && item.rr === obj.rr);
                    index ? (index.total += obj.total) : acc.push({ ...obj });
                    return acc;
                }, []);

                const RetrunResonArray = reduceReturnResonArray.map((m) => {
                    let newObj = reduceReturnResonArray.filter((n) => n.bn === m.bn && n.name === m.name);
                    newObj.name = m.bn;
                    newObj.workflow = m.name;
                    newObj.workflowID = m.workflowID;
                    return newObj;
                });

                const returnReasonsdata = RetrunResonArray.filter((m) => m.name === branchName && m.workflow === workflow).map((m) => {
                    const newObj = { name: m.name };
                    m.forEach((n) => {
                        newObj.workflow = n.name;
                        newObj[n.rr] = n.total;
                        newObj.workflowID = m.workflowID;
                    });
                    return newObj;
                });

                const groupbyRetunreson = Object.values(returnReasonsdata.reduce((acc, cur) => Object.assign(acc, { [cur.workflow]: cur }), {}));

                const mergeAllarray = returnReasonsdata.map((m) => Object.keys(m)).flat();
                const values = [...new Set(mergeAllarray)];

                setState((st) => ({
                    ...st,
                    workFlowDataBarData: groupbyRetunreson,
                    workFlowDatakeys: values,
                    returnReasonColors: RetrunResoncolor,
                    showReturnReasonLoader: false
                }));
            } else {
                // ---------------- Workflow-level (all branches) case ----------------
                const workflowRetunReasonReduce = returnReason.reduce((acc, obj) => {
                    const index = acc.find((item) => item.name === obj.name && item.rr === obj.rr);
                    if (index) {
                        index.total += obj.total;
                    } else {
                        acc.push({ ...obj });
                    }
                    return acc;
                }, []);

                const workflowArray = workflowRetunReasonReduce.map((m) => {
                    let newObj = workflowRetunReasonReduce.filter((n) => n.name === m.name);
                    newObj.name = m.name;
                    return newObj;
                });

                const workflowGroupReturnReason = Object.values(workflowArray.reduce((acc, cur) => Object.assign(acc, { [cur.name]: cur }), {}));

                const workflowRetunReasonData = workflowGroupReturnReason.map((m) => {
                    const newObj = { workflow: m.name };
                    m.forEach((n) => {
                        newObj[n.rr] = n.total;
                        newObj.workflowID = n.workflowID;
                    });
                    return newObj;
                });

                const mergeWorkFlowarray = workflowRetunReasonData.map((m) => Object.keys(m)).flat();
                const workFlowvalues = [...new Set(mergeWorkFlowarray)];

                setState((st) => ({
                    ...st,
                    workFlowDataBarData: workflowRetunReasonData,
                    workFlowDatakeys: workFlowvalues,
                    returnReasonColors: RetrunResoncolor,
                    showReturnReasonLoader: false
                }));
            }
        } catch (error) {
            console.error('Error in GetReturnReason:', error);
            setState((st) => ({
                ...st,
                showReturnReasonLoader: false,
                workFlowDataBarData: [],
                workFlowDatakeys: [],
                returnReasonColors: []
            }));
        }
    };

    const GetTechnicianData = async () => {
        try {
            let pros = [];
            pros.push(GetInternalDashTechnicianJobs(props.processID));
            let responses = await Promise.all(pros);
            if (responses[0].success) {
                let technicianJobs = [...responses[0]?.data?.technicianJobs];
                if (technicianJobs) {
                    let result = technicianJobs.map((m) => {
                        let newObj;
                        newObj = technicianJobs.filter((n) => {
                            if (n.bn === m.bn) {
                                return m;
                            }
                        });
                        newObj.bn = m.bn;
                        return newObj;
                    });
                    let newResult = Object.values(result.reduce((acc, cur) => Object.assign(acc, { [cur.bn]: cur }), {}));

                    setState((st) => ({
                        ...st,
                        technicianJobsData: newResult,
                        showTechnicianLoader: false
                    }));
                }
            }
        } catch (error) {
            console.error('Error in GetTechnicianData:', error);
            setState((st) => ({
                ...st,
                showTechnicianLoader: false,
                technicianJobsData: []
            }));
        }
    };
    useEffect(() => {
        GetClockedHours();
        GetHeaderRecords();
        GetTechnicianData();
    }, []);

    useEffect(() => {
        try {
            let btTimeData = null;
            let tempData = null;
            btTimeData = JSON.parse(localStorage.getItem('filterParams'));
            tempData = JSON.parse(localStorage.getItem('_dashboard_'));

            const workflow = tempData?.workflowReturnReason || null;
            const branchName = btTimeData?.branchShortName || null;

            GetReturnReason(workflow, branchName);
        } catch (error) {
            console.error('Error in useEffect (GetReturnReason):', error);
        }
    }, [state.selectedBranch, state.selectedWorkFlow]);

    useEffect(() => {
        try {
            const query = props?.location?.query;

            if (query) {
                setState((st) => ({
                    ...st,
                    returnReasonID: query.returnReasonID ?? null,
                    filterText: query.returnReason ?? '',
                    btnSelectedId: query.workFlowId ?? null,
                    hasQueryValues: true
                }));
            }
        } catch (error) {
            console.error('Error in useEffect (loading query params):', error);
        }
    }, []);

    const pullHeaderWorkFlowData = (params) => {
        try {
            // ensure preferences exist
            if (!Array.isArray(state.userPreferenceWorkflowsSequence) || state.userPreferenceWorkflowsSequence.length === 0) {
                console.warn('No user workflow preferences found');
                return;
            }

            // function to map preference list to totals (common for both cases)
            const buildWorkflowTotals = (sourceData, preferences) => {
                return preferences
                    .map((pref) => {
                        const found = sourceData.find((o) => o.workflowID === pref.workflowID);
                        return {
                            workflowID: pref.workflowID,
                            workflow: pref.workflow,
                            total: found ? found.total : 0,
                            orderSequence: pref.orderSequence
                        };
                    })
                    .sort((a, b) => a.orderSequence - b.orderSequence);
            };

            if (params !== 'Default') {
                if (!Array.isArray(state.rawHeaderData) || state.rawHeaderData.length === 0) {
                    console.warn('No raw header data available');
                    return;
                }

                // filter raw data by branch
                const indexObj = state.rawHeaderData.filter((inx) => inx.bn === params);

                // map workflows with totals
                const WorkflowTotal = buildWorkflowTotals(indexObj, state.userPreferenceWorkflowsSequence);

                // calculate overall totals per branch
                const overallTotal = indexObj.reduce((acc, curr) => {
                    const found = acc.find((x) => x.bn === curr.bn);
                    if (found) {
                        found.total += curr.total;
                    } else {
                        acc.push({ ...curr });
                    }
                    return acc;
                }, []);

                setState((st) => ({
                    ...st,
                    tempHeaderRecord: WorkflowTotal,
                    sumOfAllWorkflows: overallTotal[0]?.total ?? 0
                }));
            } else {
                // fallback to existing headerRecord when Default is selected
                const WorkflowTotal = buildWorkflowTotals(state.headerRecord || [], state.userPreferenceWorkflowsSequence);

                setState((st) => ({
                    ...st,
                    tempHeaderRecord: WorkflowTotal,
                    sumOfAllWorkflows: state.sumWorkflows ?? 0
                }));
            }
        } catch (error) {
            console.error('Error in pullHeaderWorkFlowData:', error);
            // safe fallback (keeps app stable)
            setState((st) => ({
                ...st,
                tempHeaderRecord: [],
                sumOfAllWorkflows: 0
            }));
        }
    };

    useEffect(() => {
        // run only if a branch is selected and preferences exist
        if (state.selectedBranch && Array.isArray(state.userPreferenceWorkflowsSequence) && state.userPreferenceWorkflowsSequence.length > 0) {
            try {
                pullHeaderWorkFlowData(state.selectedBranch);
            } catch (err) {
                console.error('Error while pulling workflow data:', err);
            }
        }
    }, [state.selectedBranch, state.rawHeaderData, state.userPreferenceWorkflowsSequence]);

    useEffect(() => {
        pullGridFilterList();
    }, [isAppReload]);

    useEffect(() => {
        try {
            if (workflowRef.current) {
                const isVisible = scrollbarVisible(workflowRef.current);
                setState((st) => ({
                    ...st,
                    isShowScrollArrow: isVisible
                }));
            }
        } catch (error) {
            console.error('Error checking scroll arrow visibility:', error);
        }
    }, [WindowWidths]);

    const handleBtnClcik = (val) => {
        props.history.push(`/Job/${val.headerRecordID}/${val.workflowID}`);
    };

    const getbranchByOnchange = (val, params) => {
        setState((st) => ({
            ...st,
            selectedBranch: val,
            selectedWorkFlow: params
        }));
    };

    const handleAssignmentBtnClick = (val) => {
        setState((st) => ({
            ...st,
            jobId: val.headerRecordID,
            showTechAssign: true
        }));
    };

    const editButton = (id, val) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container>
                <Grid style={{ marginLeft: '13px' }}>
                    <IconButton size="small" onClick={() => handleBtnClcik(val)}>
                        <ArrowForwardIosIcon
                            style={{
                                color: val.tcc
                            }}
                            fontSize="small"
                        />
                    </IconButton>
                </Grid>
                <Grid>
                    {val.technicians && (
                        <IconButton title={`${val.technicians}`} size="small" onClick={() => state.currentWorkflowId == 8 && handleAssignmentBtnClick(val)}>
                            <AssignmentIndIcon
                                style={{
                                    color: val.tcc
                                }}
                                fontSize="small"
                            />
                        </IconButton>
                    )}
                </Grid>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const baseColumns = [
        {
            title: 'Action',
            field: 'act',
            renderer: editButton,
            width: 90,
            filterable: false
        },
        { field: 'wipNo', sortable: true, title: `${portalSettings.portalSettingGridWIPNoLabel || 'WIP No'}`, width: 70 },
        { field: 'registration', sortable: true, title: `${portalSettings.portalSettingGridVehicleRegLabel || 'Vehicle Reg'}`, width: 90 },
        { field: 'makeModel', sortable: true, title: `${portalSettings.portalSettingGridModelLabel || 'Model'}`, width: 200 },
        { field: 'customerName', sortable: true, title: `${portalSettings.portalSettingGridCustomerNameLabel || 'Customer Name'}`, width: 200 },
        {
            field: 'dateDueIn',
            sortable: true,
            title: `${portalSettings.portalSettingGridDateDueInLabel || 'Date Due In'}`,
            // type: 'date',
            type: 'dateTime',
            // flex: 0.6
            width: 135,
            renderer: function (value, record) {
                if (record.dateDueIn != null) {
                    return moment(record.dateDueIn).format('DD-MMM-YYYY HH:mm');
                }
                return '';
            }
        },
        {
            field: 'dateDueOut',
            sortable: true,
            title: `${portalSettings.portalSettingGridDateDueOutLabel || 'Date Due Out'}`,
            // type: 'date',
            type: 'dateTime',
            width: 135,
            renderer: function (value, record) {
                if (record.dateDueOut != null) {
                    return moment(record.dateDueOut).format('DD-MMM-YYYY HH:mm');
                }
                return '';
            }
        },
        { field: 'returnReason', sortable: true, title: `${portalSettings.portalSettingGridReturnReasonLabel || 'Return Reason'}`, width: 190 },
        { field: 'chassisNumber', sortable: true, title: 'Chassis Number', width: 180 },
        { field: 'branchShortName', sortable: true, title: `${portalSettings.portalSettingGridBranchLabel || 'Branch'}`, width: 120 },
        { field: 'franchiseName', sortable: true, title: `${portalSettings.portalSettingGridFranchiseLabel || 'Franchise'}`, width: 160 },
        { field: 'serviceText', sortable: true, title: `${portalSettings.portalSettingGridJobDescriptionLabel || 'Job Description'}`, width: 170 },
        { field: 'accountNo', sortable: true, title: `${portalSettings.portalSettingGridAccountLabel || 'Account'}`, width: 80 },
        { field: 'createdBy', sortable: true, title: `${portalSettings.portalSettingGridCreatedByLabel || 'Created By'}`, width: 120 },
        {
            field: 'assigned',
            sortable: true,
            title: `${portalSettings.portalSettingGridAssignedDateLabel || 'Assigned Date'}`,
            width: 120,
            renderer: function (value, record) {
                if (record.assigned != null) {
                    return moment(record.assigned).format('DD-MMM-YYYY HH:mm');
                }
                return '';
            }
        },
        {
            field: 'taken',
            sortable: true,
            title: `${portalSettings.portalSettingGridTimeTakenLabel || 'Time Taken'}`,
            width: 100
        },
        {
            field: 'status',
            sortable: true,
            title: `${portalSettings.portalSettingGridStatusLabel || 'Status'}`,
            width: 100
        },
        {
            field: 'assignedDays',
            sortable: true,
            title: `${portalSettings.portalSettingGridAssignedDaysLabel || 'Assigned Days'}`,
            width: 100
        },
        {
            field: 'owningOperator',
            sortable: true,
            title: `${portalSettings.portalSettingGridOwningOperatorLabel || 'Owning Operator'}`,
            width: 100
        },
        {
            field: 'jobAssignedUser',
            sortable: true,
            title: `${portalSettings.portalSettingGridJobAssignedUserLabel || 'Assigned User'}`,
            width: 100
        },
        {
            field: 'courtesyCarReq',
            sortable: true,
            title: `${portalSettings.portalSettingGridCourtesyCarReqLabel || 'Loan Vehicle'}`,
            width: 140
        },
        {
            field: 'customerWaiting',
            sortable: true,
            title: `${portalSettings.portalSettingGridCustomerWaitingLabel || 'Customer Waiting'}`,
            width: 140
        },
        {
            field: 'wipAge',
            sortable: true,
            title: `${portalSettings.portalSettingGridWIPAgeLabel || 'WIP Age'}`,
            width: 80
        },
        {
            field: 'isNightShift',
            sortable: true,
            title: `${portalSettings.portalSettingGridIsNightShiftLabel || 'Is Night Shift'}`,
            width: 140
        }
    ]
        .map((c) => {
            let obj = {};
            if (c.title !== 'Action') {
                obj.events = {
                    click: function (e) {
                        props.history.push(`/Job/${e.data.record.headerRecordID}/${e.data.record.workflowID}`);
                    }
                };
                if (Object.keys(state.tempObj).length > 0) {
                    obj.sequenceNo = state.tempObj[config[c.field]?.getSequence] || 9999999;
                    obj.hidden = !state.tempObj[config[c.field]?.from];
                } else {
                    obj.hidden = false;
                }
            }
            if (c.title == 'Action') {
                obj.sequenceNo = -1;
            }
            return {
                ...c,
                ...obj,
                headerCssClass: 'gridHeader'
            };
        })
        .sort((a, b) => {
            return a.sequenceNo - b.sequenceNo;
        });

    const buttonClicked = async (btn, fromPage) => {
        // let tempData = {};
        let tempData = JSON.parse(localStorage.getItem('FiltterParams'));
        if (fromPage) {
            localStorage.setItem(
                'FiltterParams',
                JSON.stringify({ returnReason: btn.returnReason, branchShortName: btn.bn, branchTime: btn.time, dueTime: btn.dueTime })
            );
        } else {
            localStorage.setItem('FiltterParams', JSON.stringify({ branchShortName: tempData?.branchShortName }));
        }
        localStorage.setItem('currentWorkflowId', btn.workflowID);
        history.push(`/dashgrid?ProcessID=${props.processID}`);
    };

    const HandleStatusLink = (btn, fromPage) => {
        let { fr, status, bn } = btn;
        if (btn.isTotal) {
            let getBranchID = [...state.franchiseStatus].find((k) => k.branch === bn)?.branchID;
            history.push(`/workshopLoadingStatusCode?bn=${getBranchID || ''}`);
        } else {
            let getFranchiseCode = [...state.uniqueFranchises].find((k) => k.name === fr)?.id;
            let getBranchID = [...state.franchiseStatus].find((k) => k.branch === bn)?.branchID;
            history.push(`/workshopLoadingStatusCode?bn=${getBranchID || ''}&fn=${getFranchiseCode || ''}&status=${status}`);
        }
    };

    const handleOpen = () => {
        let tempArr = [...baseColumns]
            .map((q) => {
                return {
                    field: q.field,
                    title: q.title,
                    hidden: !q.hidden,
                    fieldName: config[q.field]?.to,
                    postSequenceFieldName: config[q.field]?.postSequence
                };
            })
            .filter((p) => (p.title !== 'Action' ? p : null));

        //.filter((p) => (p.fieldName !== undefined ? p : null));
        // tempArr.push({
        //     field: 'pagination',
        //     title: 'Pagination',
        //     hidden: state.displayPagination,
        //     fieldName: 'UserGridColumnDisplayPagination'
        // });

        setState((st) => ({ ...st, showFilter: true, filterList: tempArr }));
    };

    const closeDialog = (res) => {
        setState((st) => ({ ...st, showFilter: false, showTechAssign: false }));
        res && pullGridFilterList();
        res && GetHeaderRecords();
    };

    const closeTechAssignDialog = (res) => {
        setState((st) => ({ ...st, showTechAssign: false, isReload: res ? new Date() : null }));
    };

    return (
        <div style={{ padding: 10, background: '#f5f5f5' }}>
            <Grid container spacing={1} className="mainDashboard-container">
                <Avatar className="avatar-filter-btn" onClick={handleOpen}>
                    <FilterListIcon />
                </Avatar>
                <div className="workflow-main-container">
                    {state.isShowScrollArrow && (
                        <span onClick={() => scrollPrev()} className="ScrollArrow-Container">
                            <ChevronLeftIcon />
                        </span>
                    )}

                    <div style={{ overflow: 'auto', display: 'flex', width: '100%' }} className={`btn-container`} ref={workflowRef}>
                        {Array.isArray(state.tempHeaderRecord) &&
                            state.tempHeaderRecord.map((m, i) => {
                                if (m?.workflow !== 'Archived') {
                                    return (
                                        <div item className="workflow-container-padding" key={m?.workflowID || i}>
                                            <Card
                                                className={`workflow-card-design ${state.btnID === m?.workflowID ? 'workflow-card-design-isActive' : ''}`}
                                                onClick={() => buttonClicked(m)}
                                            >
                                                <div className="workflow-labels">
                                                    <span>{m?.workflow || 'N/A'}</span>
                                                    <div>{m?.total}</div>
                                                </div>
                                            </Card>
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })}

                        <div item className="workflow-container-padding">
                            <Card
                                className={`workflow-card-design ${state.total === 'total' ? 'workflow-card-design-isActive' : ''}`}
                                onClick={() => buttonClicked({ workflowID: 'All' })}
                            >
                                <div className="workflow-labels">
                                    <span>Total</span>
                                    <div>{state?.sumOfAllWorkflows ?? 0}</div>
                                </div>
                            </Card>
                        </div>
                    </div>

                    {state.isShowScrollArrow && (
                        <span onClick={() => scrollNext()} className="ScrollArrow-Container">
                            <ChevronRightIcon />
                        </span>
                    )}
                </div>
                <DashboardCharts
                    state={state}
                    onChartClickHandler={buttonClicked}
                    getbranchByOnchange={getbranchByOnchange}
                    HandleStatusLink={HandleStatusLink}
                />
            </Grid>
            {/* )} */}
            {state.showFilter ? (
                <DialogComp title="My Preferences" maxWidth="md" fullWidth onClose={() => closeDialog(false)} overflow="auto">
                    <FilterModalMainTabComponent
                        languageCode={state.languageCode}
                        appbarLocation={state.appbarLocation}
                        filterConfig={config}
                        filterList={state.filterList}
                        handleCancel={closeDialog}
                        languageData={state.languageData}
                        isPagination={state.displayPagination}
                        showJobHeader={state.showJobHeader}
                        ProcessID={props.processID}
                    />
                    {/* <GridFilterModal
                        UserPreferenceWorkflowsList={state.UserPreferenceWorkflowsList}
                        languageCode={state.languageCode}
                        appbarLocation={state.appbarLocation}
                        filterConfig={config}
                        filterList={state.filterList}
                        handleCancel={closeDialog}
                        languageData={state.languageData}
                    /> */}
                </DialogComp>
            ) : null}
            {state.showTechAssign ? (
                <DialogComp title="Assigned Technician" maxWidth="sm" onClose={() => closeTechAssignDialog(false)} fullWidth>
                    <AssignTech jobId={state.jobId} handleCancel={closeTechAssignDialog} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default Dashbord;
